import { Container, Typography } from "@mui/material";

const NotFound = () => {
  return (
    <Container>
      <Typography>PAGE NOT FOUND 404</Typography>
    </Container>
  );
};

export default NotFound;
